// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-version {
  background-color: #4e4e4e;
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: center;*/
}

.dark-version .div {
  background-color: #4e4e4e;
  height: 737px;
  /* overflow: hidden; */
  position: relative;
  width: 100%;
}

.dark-version .overlap {
  /*height: 526px;*/
  /*left: 112px;*/
  position: relative;
  /*top: 152px;*/
  width: "100%";
  height:"100%";
}

.dark-version .rectangle {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 24px #00000012;
  /*height: 478px;*/
  left: 0;
  position: relative;
  /*top: 48px;*/
  /*width: 548px;*/
}

.dark-version .total-bar-holder {
  background-color: #a4a4a4;
  left: 0;
  position: relative;

  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  align-content: center;
  /*top: 369px;*/
  /*width: 548px;*/
}

.dark-version .rectangle-2 {
  background: linear-gradient(
    180deg,
    rgb(255, 255, 255) 0%,
    rgb(221, 221, 221) 100%
  );
  /*height: 60px;*/
  left: 0;
  position: relative;
  /*top: 399px;*/
  /*width: 100%;*/
}

.dark-version .line {
  height: 149px;
  left: 169px;
  object-fit: cover;
  position: relative;
  top: 142px;
  width: 1px;
}

.dark-version .img {
  height: 51px;
  left: 169px;
  object-fit: cover;
  position: relative;
  top: 312px;
  width: 1px;
}

.dark-version .line-2 {
  height: 51px;
  left: 169px;
  object-fit: cover;
  position: relative;
  top: 404px;
  width: 1px;
}

.dark-version .line-3 {
  height: 51px;
  left: 292px;
  object-fit: cover;
  position: relative;
  top: 312px;
  width: 1px;
}

.dark-version .line-4 {
  height: 149px;
  left: 292px;
  object-fit: cover;
  position: relative;
  top: 142px;
  width: 1px;
}

.dark-version .line-5 {
  height: 51px;
  left: 415px;
  object-fit: cover;
  position: relative;
  top: 312px;
  width: 1px;
}

.dark-version .line-6 {
  height: 51px;
  left: 292px;
  object-fit: cover;
  position: relative;
  top: 404px;
  width: 1px;
}

.dark-version .line-7 {
  height: 149px;
  left: 415px;
  object-fit: cover;
  position: relative;
  top: 142px;
  width: 1px;
}

.dark-version .line-8 {
  height: 51px;
  left: 415px;
  object-fit: cover;
  position: relative;
  top: 404px;
  width: 1px;
}
.dark-version .category-box{
  /*height:100%;*/
  background-color: #f0f8ee;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.dark-version .category {
  color: #000000;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 19px;
  font-weight: 700;
  /*left: -30px;*/
  letter-spacing: 0;
  /*line-height: 21px;*/
  position: relative;
  /*top: 219px;*/
  transform: rotate(-90deg);
  /*white-space: nowrap;*/
}

.dark-version .text-wrapper {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 19px;
  font-weight: 700;
  /*left: 254px;*/
  /*letter-spacing: 0;*/
  /*line-height: 21px;*/
  /*position: relative;*/
  /*top: 372px;*/
  white-space: nowrap;
}

.dark-version .tab-grayholder {
  background-color: #636363;
  border-radius: 16px 16px 16px 16px;
  /*height: 96px;*/
  /*height: 20%;*/
  left: 0;
  position: relative;
  top: 0;
  /*width: 548px;*/
}

.dark-version .pipeline {
  background-color: #ff8c04;
  border-radius: 5px;
  box-shadow: 0px 4px 4px #00000026;
  height: 29px;
  /*left: 56px;*/
  position: relative;
  /*top: 202px;*/
  /*width: 472px;*/
}

.dark-version .signed {
  background-color: #1fa23c;
  border-radius: 5px;
  box-shadow: 0px 4px 4px #00000026;
  height: 30px;
  /*left: 56px;*/
  position: relative;
  /*top: 113px;*/
  /*width: 80%;*/
}

.dark-version .text-wrapper-2 {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 23px;
  font-weight: 700;
  left: 221px;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  top: 291.5px;
  white-space: nowrap;
}

.dark-version .text-wrapper-3 {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 23px;
  font-weight: 700;
  left: 230px;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  top: 205.5px;
  white-space: nowrap;
}

.dark-version .text-wrapper-cat {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 23px;
  font-weight: 700;
  /*left: 240px;*/
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  /*top: 117.5px;*/
  white-space: nowrap;
}

.dark-version .flexcontainer {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  /*gap: 2px;*/
  /*height: 32px;*/
  /*left: 50px;*/
  /*position: relative;*/
  /*top: 40px;*/
  /*width: 99px;*/
}
.dark-version .header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 200px; /* Set your desired height */
  width: 200px; /* Set your desired width */
  /*border: 1px solid #ccc; !* Optional border for visualization *!*/
}

.dark-version .text {
  align-self: stretch;
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 15px;
  position: relative;
  text-align: center;
}

.dark-version .span {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 15px;
}

.dark-version .cat-table-text {
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  /*left: 102px;*/
  letter-spacing: 0;
  line-height: normal;
  /*position: relative;*/
  text-align: center;
  /*top: 160px;*/
}

.dark-version .text-wrapper-6 {
  color: #ff823c;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 102px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 247px;
}

.dark-version .text-wrapper-7 {
  color: #fb1414;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 102px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 332px;
}

.dark-version .text-wrapper-8 {
  color: #28ac45;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 227px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 160px;
}

.dark-version .text-wrapper-9 {
  color: #ff823c;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 226px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 247px;
}

.dark-version .text-wrapper-10 {
  color: #fb1414;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 227px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 332px;
}

.dark-version .text-wrapper-11 {
  color: #28ac45;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 320px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 160px;
}

.dark-version .text-wrapper-12 {
  color: #ff823c;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 328px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 247px;
}

.dark-version .text-wrapper-13 {
  color: #fb1414;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 333px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 332px;
}

.dark-version .p {
  color: #fb1414;
  font-family: "Arial-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  left: 110px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 460px;
  white-space: nowrap;
}

.dark-version .text-wrapper-14 {
  color: #28ac45;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 442px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 160px;
}

.dark-version .text-wrapper-15 {
  color: #ff823c;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 451px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 247px;
}

.dark-version .text-wrapper-16 {
  color: #fb1414;
  font-family: "Barlow", Helvetica;
  font-size: 19px;
  font-weight: 500;
  left: 456px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  top: 332px;
}

.dark-version .amount {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 16px;
  font-weight: 700;
  left: 187px;
  letter-spacing: 0;
  line-height: 21px;
  position: relative;
  text-align: center;
  top: 59px;
  white-space: nowrap;
  width: 89px;
}

.dark-version .disbursed {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 16px;
  font-weight: 700;
  left: 309px;
  letter-spacing: 0;
  line-height: 21px;
  position: relative;
  text-align: center;
  top: 60px;
  white-space: nowrap;
}

.dark-version .undisbursed {
  color: #ffffff;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 16px;
  font-weight: 700;
  left: 423px;
  letter-spacing: 0;
  line-height: 21px;
  position: relative;
  text-align: center;
  top: 60px;
  white-space: nowrap;
}

.dark-version .text-wrapper-17 {
  color: #000000;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 96px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 417px;
  white-space: nowrap;
}

.dark-version .text-wrapper-18 {
  color: #000000;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 227px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 417px;
  white-space: nowrap;
}

.dark-version .text-wrapper-19 {
  color: #000000;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 312px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 417px;
  white-space: nowrap;
}

.dark-version .text-wrapper-20 {
  color: #000000;
  font-family: "Barlow Semi Condensed", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 430px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 417px;
  white-space: nowrap;
}

.dark-version .ellipse {
  background-color: #28ac45;
  border-radius: 4.15px;
  height: 8px;
  left: 38px;
  position: relative;
  top: 123px;
  width: 8px;
}

.dark-version .ellipse-2 {
  background-color: #ff8c04;
  border-radius: 4.15px;
  height: 8px;
  left: 38px;
  position: relative;
  top: 214px;
  width: 8px;
}

.dark-version .ellipse-3 {
  background-color: #ff0707;
  border-radius: 4.15px;
  height: 8px;
  left: 38px;
  position: relative;
  top: 336px;
  width: 8px;
}

.dark-version .line-9 {
  height: 74px;
  left: 42px;
  object-fit: cover;
  position: relative;
  top: 134px;
  width: 1px;
}

.dark-version .line-10 {
  height: 106px;
  left: 42px;
  object-fit: cover;
  position: relative;
  top: 227px;
  width: 1px;
}

.dark-version .divider-b {
  height: 2px;
  left: 2px;
  position: relative;
  top: 458px;
  width: 544px;
}

.dark-version .potential {
  background-color: #ff0707;
  border-radius: 5px;
  box-shadow: 0px 4px 4px #00000026;
  height: 29px;
  /*left: 56px;*/
  position: relative;
  /*top: 287px;*/
  /*width: 472px;*/
}

.dark-version .devider {
  height: 95px;
  left: 169px;
  position: relative;
  top: 1px;
  width: 246px;
}

.dark-version .line-11 {
  height: 95px;
  left: 0;
  object-fit: cover;
  position: relative;
  top: 0;
  width: 1px;
}

.dark-version .line-12 {
  height: 95px;
  left: 123px;
  object-fit: cover;
  position: relative;
  top: 0;
  width: 1px;
}

.dark-version .line-13 {
  height: 95px;
  left: 246px;
  object-fit: cover;
  position: relative;
  top: 0;
  width: 1px;
}

.dark-version .mask-group {
  height: 15px;
  left: 24px;
  position: relative;
  top: 496px;
  width: 491px;
}

.dark-version .projects-icon {
  height: 22px;
  left: 92px;
  position: relative;
  top: 20px;
  width: 27px;
}

.dark-version .ammount-icon {
  height: 28px;
  left: 220px;
  position: relative;
  top: 18px;
  width: 28px;
}

.dark-version .distributed {
  height: 38px;
  left: 333px;
  position: relative;
  top: 14px;
  width: 38px;
}

.dark-version .undistributed {
  height: 38px;
  left: 456px;
  position: relative;
  top: 14px;
  width: 38px;
}

.dark-version .overlap-group {
  background-color: #60bf75;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 4px 44px #0000001a;
  height: 34px;
  left: 114px;
  position: relative;
  top: 90px;
  width: 1139px;
}

.dark-version .national-portfolio {
  color: #090909;
  font-family: "Montserrat", Helvetica;
  font-size: 17px;
  font-weight: 700;
  left: 379px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: -10px;
}

.dark-version .overlap-group-2 {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 24px #00000012;
  height: 534px;
  left: 683px;
  position: relative;
  top: 153px;
  width: 570px;
}

.dark-version .PROVINCIAL {
  color: #443838;
  font-family: "Barlow", Helvetica;
  font-size: 18px;
  font-weight: 550;
  left: 177px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 79px;
}

.dark-version .div-wrapper {
  background: linear-gradient(
    180deg,
    rgb(251.81, 251.81, 251.81) 0%,
    rgb(238, 238, 238) 100%
  );
  border-radius: 8px 0px 0px 0px;
  box-shadow: 0px 1px 1px #00000040;
  height: 50px;
  left: 1px;
  position: relative;
  top: 2px;
  width: 292px;
}

.dark-version .text-wrapper-21 {
  color: #443838;
  font-family: "Barlow", Helvetica;
  font-size: 15px;
  font-weight: 700;
  left: 100px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  white-space: nowrap;
}

.dark-version .text-wrapper-22 {
  color: #443838;
  font-family: "Barlow", Helvetica;
  font-size: 15px;
  font-weight: 700;
  left: 381px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 17px;
  white-space: nowrap;
}

.dark-version .image {
  height: 384px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 125px;
  width: 525px;
}

.dark-version .navbar {
  background: linear-gradient(
    180deg,
    rgb(69.06, 67.62, 67.62) 0%,
    rgb(78.63, 78.63, 78.63) 100%
  );
  box-shadow: 0px 4px 44px #0000001a;
  height: 90px;
  left: 92px;
  position: relative;
  top: 0;
  width: 1188px;
}

.dark-version .overlap-2 {
  background: linear-gradient(
    180deg,
    rgb(15.94, 127.5, 40.48) 0%,
    rgb(40.16, 172.13, 69.19) 100%
  );
  border-radius: 18px 8px 0px 0px;
  height: 38px;
  left: 22px;
  position: relative;
  top: 52px;
  width: 801px;
}

.dark-version .text-wrapper-23 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 17px;
  font-weight: 550;
  left: 106px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  white-space: nowrap;
  top: -10px;
}

.dark-version .overlap-3 {
  background: linear-gradient(
    180deg,
    rgb(255, 255, 255) 0%,
    rgba(243.31, 243.31, 243.31, 0.85) 100%
  );
  border-radius: 8px 8px 0px 0px;
  height: 35px;
  left: 826px;
  position: relative;
  top: 52px;
  width: 194px;
}

.dark-version .text-wrapper-24 {
  color: #000000;
  font-family: "Lato", Helvetica;
  font-size: 16px;
  font-weight: 700;
  left: 63px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 8px;
  white-space: nowrap;
}

.dark-version .info-icon {
  height: 15px;
  left: 42px;
  position: relative;
  top: 9px;
  width: 15px;
}

.dark-version .overlap-4 {
  background: linear-gradient(
    180deg,
    rgb(251.81, 251.81, 251.81) 0%,
    rgba(243.31, 243.31, 243.31, 0.85) 100%
  );
  border-radius: 8px 8px 0px 0px;
  height: 35px;
  left: 1024px;
  position: relative;
  top: 52px;
  width: 135px;
}

.dark-version .text-wrapper-25 {
  color: #000000;
  font-family: "Lato", Helvetica;
  font-size: 14px;
  font-weight: 400;
  left: 33px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 8px;
}

.dark-version .PROJECT-MANAGEMENT {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 16px;
  font-weight: 550;
  left: 28px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  white-space: nowrap;
}

.dark-version .text-wrapper-26 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: 745px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  width: 36px;
}

.dark-version .text-wrapper-27 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: 816px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  width: 33px;
}

.dark-version .text-wrapper-28 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: 884px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  width: 49px;
}

.dark-version .text-wrapper-29 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: 968px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  width: 150px;
}

.dark-version .text-wrapper-30 {
  color: #ffffff;
  font-family: "Lato", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: 1085px;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  top: 13px;
  width: 47px;
}

.dark-version .news-icon {
  height: 12px;
  left: 797px;
  position: relative;
  top: 16px;
  width: 14px;
}

.dark-version .projects-icon-2 {
  height: 13px;
  left: 860px;
  position: relative;
  top: 15px;
  width: 16px;
}

.dark-version .compare-icon {
  height: 12px;
  left: 943px;
  position: relative;
  top: 16px;
  width: 16px;
}

.dark-version .mangehistory-icon {
  height: 13px;
  left: 1065px;
  position: relative;
  top: 15px;
  width: 13px;
}

.dark-version .divider {
  height: 2px;
  left: 28px;
  position: relative;
  top: 42px;
  width: 1160px;
}

.dark-version .hanburg-menu {
  height: 22px;
  left: 1174px;
  position: relative;
  top: 10px;
  width: 5px;
}

.dark-version .rectangle-3 {
  background-color: #ffffff;
  border-radius: 23px;
  height: 5px;
  left: 0;
  position: relative;
  top: 0;
  width: 5px;
}

.dark-version .rectangle-4 {
  background-color: #ffffff;
  border-radius: 23px;
  height: 5px;
  left: 0;
  position: relative;
  top: 8px;
  width: 5px;
}

.dark-version .rectangle-5 {
  background-color: #ffffff;
  border-radius: 23px;
  height: 5px;
  left: 0;
  position: relative;
  top: 17px;
  width: 5px;
}

.dark-version .overlap-5 {
  background-color: #414141;
  box-shadow: 0px 0px 15px #00000017;
  height: 650px;
  left: -13px;
  position: relative;
  top: 87px;
  width: 105px;
}

.dark-version .energy {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 10px;
  font-weight: 600;
  left: 37px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 36px;
  white-space: nowrap;
}

.dark-version .water {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 9px;
  font-weight: 600;
  left: 42px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 100px;
  white-space: nowrap;
}

.dark-version .communi-cation {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 9px;
  font-weight: 600;
  left: 32px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 156px;
}

.dark-version .finance-revenue {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 9px;
  font-weight: 600;
  left: 32px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 221px;
}

.dark-version .social-sector {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 9px;
  font-weight: 600;
  left: 39px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 286px;
}

.dark-version .govt-of-punjab {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  left: 39px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 362px;
}

.dark-version .text-wrapper-31 {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 12px;
}

.dark-version .text-wrapper-32 {
  font-size: 9px;
}

.dark-version .govt-of-sindh {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  left: 43px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 492px;
}

.dark-version .overlap-6 {
  height: 54px;
  left: 43px;
  position: relative;
  top: 397px;
  width: 32px;
}

.dark-version .govt-of-KP {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  left: 0;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 30px;
}

.dark-version .kp {
  height: 31px;
  left: 8px;
  position: relative;
  top: 0;
  width: 22px;
}

.dark-version .govt-of-balochistan {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  left: 25px;
  letter-spacing: 0;
  line-height: 11px;
  position: relative;
  text-align: center;
  top: 555px;
}

.dark-version .text-wrapper-33 {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 6px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 11px;
}

.dark-version .text-wrapper-34 {
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 9px;
  font-weight: 600;
  left: 32px;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  text-align: center;
  top: 606px;
  width: 54px;
}

.dark-version .finance {
  height: 22px;
  left: 47px;
  position: relative;
  top: 195px;
  width: 22px;
}

.dark-version .socialsector {
  height: 15px;
  left: 50px;
  position: relative;
  top: 266px;
  width: 18px;
}

.dark-version .bulb {
  height: 26px;
  left: 46px;
  position: relative;
  top: 7px;
  width: 25px;
}

.dark-version .comunicatin {
  height: 18px;
  left: 47px;
  position: relative;
  top: 131px;
  width: 25px;
}

.dark-version .water-2 {
  height: 29px;
  left: 45px;
  position: relative;
  top: 65px;
  width: 29px;
}

.dark-version .punjab {
  height: 25px;
  left: 51px;
  position: relative;
  top: 331px;
  width: 21px;
}

.dark-version .balochistan {
  height: 23px;
  left: 46px;
  position: relative;
  top: 528px;
  width: 26px;
}

.dark-version .sindh {
  height: 22px;
  left: 49px;
  position: relative;
  top: 463px;
  width: 19px;
}

.dark-version .line-14 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 55px;
  width: 75px;
}

.dark-version .line-15 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 122px;
  width: 75px;
}

.dark-version .line-16 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 189px;
  width: 75px;
}

.dark-version .line-17 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 259px;
  width: 75px;
}

.dark-version .line-18 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 318px;
  width: 75px;
}

.dark-version .line-19 {
  height: 1px;
  left: 22px;
  object-fit: cover;
  position: relative;
  top: 599px;
  width: 75px;
}

.dark-version .logo-wrapper {
  background-color: #ffffff;
  border: 1px solid;
  border-color: #d9d9d9;
  box-shadow: 0px 0px 15px #00000017;
  height: 87px;
  left: 1px;
  position: relative;
  top: 0;
  width: 91px;
}

.dark-version .logo {
  height: 57px;
  left: 19px;
  mix-blend-mode: darken;
  position: relative;
  top: 10px;
  width: 52px;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/DarkVersionStyle.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,OAAO;EACP,kBAAkB;;EAElB,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;;;;GAIC;EACD,gBAAgB;EAChB,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa,EAAE,4BAA4B;EAC3C,YAAY,EAAE,2BAA2B;EACzC,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;;;;GAIC;EACD,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE;;;;GAIC;EACD,kCAAkC;EAClC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE;;;;GAIC;EACD,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;;;;GAIC;EACD,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;;;;GAIC;EACD,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb","sourcesContent":[".dark-version {\n  background-color: #4e4e4e;\n  /*display: flex;*/\n  /*flex-direction: row;*/\n  /*justify-content: center;*/\n}\n\n.dark-version .div {\n  background-color: #4e4e4e;\n  height: 737px;\n  /* overflow: hidden; */\n  position: relative;\n  width: 100%;\n}\n\n.dark-version .overlap {\n  /*height: 526px;*/\n  /*left: 112px;*/\n  position: relative;\n  /*top: 152px;*/\n  width: \"100%\";\n  height:\"100%\";\n}\n\n.dark-version .rectangle {\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0px 4px 24px #00000012;\n  /*height: 478px;*/\n  left: 0;\n  position: relative;\n  /*top: 48px;*/\n  /*width: 548px;*/\n}\n\n.dark-version .total-bar-holder {\n  background-color: #a4a4a4;\n  left: 0;\n  position: relative;\n\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n  align-content: center;\n  /*top: 369px;*/\n  /*width: 548px;*/\n}\n\n.dark-version .rectangle-2 {\n  background: linear-gradient(\n    180deg,\n    rgb(255, 255, 255) 0%,\n    rgb(221, 221, 221) 100%\n  );\n  /*height: 60px;*/\n  left: 0;\n  position: relative;\n  /*top: 399px;*/\n  /*width: 100%;*/\n}\n\n.dark-version .line {\n  height: 149px;\n  left: 169px;\n  object-fit: cover;\n  position: relative;\n  top: 142px;\n  width: 1px;\n}\n\n.dark-version .img {\n  height: 51px;\n  left: 169px;\n  object-fit: cover;\n  position: relative;\n  top: 312px;\n  width: 1px;\n}\n\n.dark-version .line-2 {\n  height: 51px;\n  left: 169px;\n  object-fit: cover;\n  position: relative;\n  top: 404px;\n  width: 1px;\n}\n\n.dark-version .line-3 {\n  height: 51px;\n  left: 292px;\n  object-fit: cover;\n  position: relative;\n  top: 312px;\n  width: 1px;\n}\n\n.dark-version .line-4 {\n  height: 149px;\n  left: 292px;\n  object-fit: cover;\n  position: relative;\n  top: 142px;\n  width: 1px;\n}\n\n.dark-version .line-5 {\n  height: 51px;\n  left: 415px;\n  object-fit: cover;\n  position: relative;\n  top: 312px;\n  width: 1px;\n}\n\n.dark-version .line-6 {\n  height: 51px;\n  left: 292px;\n  object-fit: cover;\n  position: relative;\n  top: 404px;\n  width: 1px;\n}\n\n.dark-version .line-7 {\n  height: 149px;\n  left: 415px;\n  object-fit: cover;\n  position: relative;\n  top: 142px;\n  width: 1px;\n}\n\n.dark-version .line-8 {\n  height: 51px;\n  left: 415px;\n  object-fit: cover;\n  position: relative;\n  top: 404px;\n  width: 1px;\n}\n.dark-version .category-box{\n  /*height:100%;*/\n  background-color: #f0f8ee;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n}\n.dark-version .category {\n  color: #000000;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 19px;\n  font-weight: 700;\n  /*left: -30px;*/\n  letter-spacing: 0;\n  /*line-height: 21px;*/\n  position: relative;\n  /*top: 219px;*/\n  transform: rotate(-90deg);\n  /*white-space: nowrap;*/\n}\n\n.dark-version .text-wrapper {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 19px;\n  font-weight: 700;\n  /*left: 254px;*/\n  /*letter-spacing: 0;*/\n  /*line-height: 21px;*/\n  /*position: relative;*/\n  /*top: 372px;*/\n  white-space: nowrap;\n}\n\n.dark-version .tab-grayholder {\n  background-color: #636363;\n  border-radius: 16px 16px 16px 16px;\n  /*height: 96px;*/\n  /*height: 20%;*/\n  left: 0;\n  position: relative;\n  top: 0;\n  /*width: 548px;*/\n}\n\n.dark-version .pipeline {\n  background-color: #ff8c04;\n  border-radius: 5px;\n  box-shadow: 0px 4px 4px #00000026;\n  height: 29px;\n  /*left: 56px;*/\n  position: relative;\n  /*top: 202px;*/\n  /*width: 472px;*/\n}\n\n.dark-version .signed {\n  background-color: #1fa23c;\n  border-radius: 5px;\n  box-shadow: 0px 4px 4px #00000026;\n  height: 30px;\n  /*left: 56px;*/\n  position: relative;\n  /*top: 113px;*/\n  /*width: 80%;*/\n}\n\n.dark-version .text-wrapper-2 {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 23px;\n  font-weight: 700;\n  left: 221px;\n  letter-spacing: 0;\n  line-height: 22px;\n  position: relative;\n  top: 291.5px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-3 {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 23px;\n  font-weight: 700;\n  left: 230px;\n  letter-spacing: 0;\n  line-height: 22px;\n  position: relative;\n  top: 205.5px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-cat {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 23px;\n  font-weight: 700;\n  /*left: 240px;*/\n  letter-spacing: 0;\n  line-height: 22px;\n  position: relative;\n  /*top: 117.5px;*/\n  white-space: nowrap;\n}\n\n.dark-version .flexcontainer {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  /*gap: 2px;*/\n  /*height: 32px;*/\n  /*left: 50px;*/\n  /*position: relative;*/\n  /*top: 40px;*/\n  /*width: 99px;*/\n}\n.dark-version .header-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  height: 200px; /* Set your desired height */\n  width: 200px; /* Set your desired width */\n  /*border: 1px solid #ccc; !* Optional border for visualization *!*/\n}\n\n.dark-version .text {\n  align-self: stretch;\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 15px;\n  position: relative;\n  text-align: center;\n}\n\n.dark-version .span {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 15px;\n}\n\n.dark-version .cat-table-text {\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  /*left: 102px;*/\n  letter-spacing: 0;\n  line-height: normal;\n  /*position: relative;*/\n  text-align: center;\n  /*top: 160px;*/\n}\n\n.dark-version .text-wrapper-6 {\n  color: #ff823c;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 102px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 247px;\n}\n\n.dark-version .text-wrapper-7 {\n  color: #fb1414;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 102px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 332px;\n}\n\n.dark-version .text-wrapper-8 {\n  color: #28ac45;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 227px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 160px;\n}\n\n.dark-version .text-wrapper-9 {\n  color: #ff823c;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 226px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 247px;\n}\n\n.dark-version .text-wrapper-10 {\n  color: #fb1414;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 227px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 332px;\n}\n\n.dark-version .text-wrapper-11 {\n  color: #28ac45;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 320px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 160px;\n}\n\n.dark-version .text-wrapper-12 {\n  color: #ff823c;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 328px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 247px;\n}\n\n.dark-version .text-wrapper-13 {\n  color: #fb1414;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 333px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 332px;\n}\n\n.dark-version .p {\n  color: #fb1414;\n  font-family: \"Arial-Regular\", Helvetica;\n  font-size: 14px;\n  font-weight: 400;\n  left: 110px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 460px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-14 {\n  color: #28ac45;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 442px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 160px;\n}\n\n.dark-version .text-wrapper-15 {\n  color: #ff823c;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 451px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 247px;\n}\n\n.dark-version .text-wrapper-16 {\n  color: #fb1414;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 19px;\n  font-weight: 500;\n  left: 456px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  text-align: center;\n  top: 332px;\n}\n\n.dark-version .amount {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  left: 187px;\n  letter-spacing: 0;\n  line-height: 21px;\n  position: relative;\n  text-align: center;\n  top: 59px;\n  white-space: nowrap;\n  width: 89px;\n}\n\n.dark-version .disbursed {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  left: 309px;\n  letter-spacing: 0;\n  line-height: 21px;\n  position: relative;\n  text-align: center;\n  top: 60px;\n  white-space: nowrap;\n}\n\n.dark-version .undisbursed {\n  color: #ffffff;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  left: 423px;\n  letter-spacing: 0;\n  line-height: 21px;\n  position: relative;\n  text-align: center;\n  top: 60px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-17 {\n  color: #000000;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 96px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 417px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-18 {\n  color: #000000;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 227px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 417px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-19 {\n  color: #000000;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 312px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 417px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-20 {\n  color: #000000;\n  font-family: \"Barlow Semi Condensed\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 430px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 417px;\n  white-space: nowrap;\n}\n\n.dark-version .ellipse {\n  background-color: #28ac45;\n  border-radius: 4.15px;\n  height: 8px;\n  left: 38px;\n  position: relative;\n  top: 123px;\n  width: 8px;\n}\n\n.dark-version .ellipse-2 {\n  background-color: #ff8c04;\n  border-radius: 4.15px;\n  height: 8px;\n  left: 38px;\n  position: relative;\n  top: 214px;\n  width: 8px;\n}\n\n.dark-version .ellipse-3 {\n  background-color: #ff0707;\n  border-radius: 4.15px;\n  height: 8px;\n  left: 38px;\n  position: relative;\n  top: 336px;\n  width: 8px;\n}\n\n.dark-version .line-9 {\n  height: 74px;\n  left: 42px;\n  object-fit: cover;\n  position: relative;\n  top: 134px;\n  width: 1px;\n}\n\n.dark-version .line-10 {\n  height: 106px;\n  left: 42px;\n  object-fit: cover;\n  position: relative;\n  top: 227px;\n  width: 1px;\n}\n\n.dark-version .divider-b {\n  height: 2px;\n  left: 2px;\n  position: relative;\n  top: 458px;\n  width: 544px;\n}\n\n.dark-version .potential {\n  background-color: #ff0707;\n  border-radius: 5px;\n  box-shadow: 0px 4px 4px #00000026;\n  height: 29px;\n  /*left: 56px;*/\n  position: relative;\n  /*top: 287px;*/\n  /*width: 472px;*/\n}\n\n.dark-version .devider {\n  height: 95px;\n  left: 169px;\n  position: relative;\n  top: 1px;\n  width: 246px;\n}\n\n.dark-version .line-11 {\n  height: 95px;\n  left: 0;\n  object-fit: cover;\n  position: relative;\n  top: 0;\n  width: 1px;\n}\n\n.dark-version .line-12 {\n  height: 95px;\n  left: 123px;\n  object-fit: cover;\n  position: relative;\n  top: 0;\n  width: 1px;\n}\n\n.dark-version .line-13 {\n  height: 95px;\n  left: 246px;\n  object-fit: cover;\n  position: relative;\n  top: 0;\n  width: 1px;\n}\n\n.dark-version .mask-group {\n  height: 15px;\n  left: 24px;\n  position: relative;\n  top: 496px;\n  width: 491px;\n}\n\n.dark-version .projects-icon {\n  height: 22px;\n  left: 92px;\n  position: relative;\n  top: 20px;\n  width: 27px;\n}\n\n.dark-version .ammount-icon {\n  height: 28px;\n  left: 220px;\n  position: relative;\n  top: 18px;\n  width: 28px;\n}\n\n.dark-version .distributed {\n  height: 38px;\n  left: 333px;\n  position: relative;\n  top: 14px;\n  width: 38px;\n}\n\n.dark-version .undistributed {\n  height: 38px;\n  left: 456px;\n  position: relative;\n  top: 14px;\n  width: 38px;\n}\n\n.dark-version .overlap-group {\n  background-color: #60bf75;\n  border-radius: 0px 0px 10px 10px;\n  box-shadow: 0px 4px 44px #0000001a;\n  height: 34px;\n  left: 114px;\n  position: relative;\n  top: 90px;\n  width: 1139px;\n}\n\n.dark-version .national-portfolio {\n  color: #090909;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 17px;\n  font-weight: 700;\n  left: 379px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: -10px;\n}\n\n.dark-version .overlap-group-2 {\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0px 4px 24px #00000012;\n  height: 534px;\n  left: 683px;\n  position: relative;\n  top: 153px;\n  width: 570px;\n}\n\n.dark-version .PROVINCIAL {\n  color: #443838;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 18px;\n  font-weight: 550;\n  left: 177px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 79px;\n}\n\n.dark-version .div-wrapper {\n  background: linear-gradient(\n    180deg,\n    rgb(251.81, 251.81, 251.81) 0%,\n    rgb(238, 238, 238) 100%\n  );\n  border-radius: 8px 0px 0px 0px;\n  box-shadow: 0px 1px 1px #00000040;\n  height: 50px;\n  left: 1px;\n  position: relative;\n  top: 2px;\n  width: 292px;\n}\n\n.dark-version .text-wrapper-21 {\n  color: #443838;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 15px;\n  font-weight: 700;\n  left: 100px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-22 {\n  color: #443838;\n  font-family: \"Barlow\", Helvetica;\n  font-size: 15px;\n  font-weight: 700;\n  left: 381px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 17px;\n  white-space: nowrap;\n}\n\n.dark-version .image {\n  height: 384px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 125px;\n  width: 525px;\n}\n\n.dark-version .navbar {\n  background: linear-gradient(\n    180deg,\n    rgb(69.06, 67.62, 67.62) 0%,\n    rgb(78.63, 78.63, 78.63) 100%\n  );\n  box-shadow: 0px 4px 44px #0000001a;\n  height: 90px;\n  left: 92px;\n  position: relative;\n  top: 0;\n  width: 1188px;\n}\n\n.dark-version .overlap-2 {\n  background: linear-gradient(\n    180deg,\n    rgb(15.94, 127.5, 40.48) 0%,\n    rgb(40.16, 172.13, 69.19) 100%\n  );\n  border-radius: 18px 8px 0px 0px;\n  height: 38px;\n  left: 22px;\n  position: relative;\n  top: 52px;\n  width: 801px;\n}\n\n.dark-version .text-wrapper-23 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 17px;\n  font-weight: 550;\n  left: 106px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  white-space: nowrap;\n  top: -10px;\n}\n\n.dark-version .overlap-3 {\n  background: linear-gradient(\n    180deg,\n    rgb(255, 255, 255) 0%,\n    rgba(243.31, 243.31, 243.31, 0.85) 100%\n  );\n  border-radius: 8px 8px 0px 0px;\n  height: 35px;\n  left: 826px;\n  position: relative;\n  top: 52px;\n  width: 194px;\n}\n\n.dark-version .text-wrapper-24 {\n  color: #000000;\n  font-family: \"Lato\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  left: 63px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 8px;\n  white-space: nowrap;\n}\n\n.dark-version .info-icon {\n  height: 15px;\n  left: 42px;\n  position: relative;\n  top: 9px;\n  width: 15px;\n}\n\n.dark-version .overlap-4 {\n  background: linear-gradient(\n    180deg,\n    rgb(251.81, 251.81, 251.81) 0%,\n    rgba(243.31, 243.31, 243.31, 0.85) 100%\n  );\n  border-radius: 8px 8px 0px 0px;\n  height: 35px;\n  left: 1024px;\n  position: relative;\n  top: 52px;\n  width: 135px;\n}\n\n.dark-version .text-wrapper-25 {\n  color: #000000;\n  font-family: \"Lato\", Helvetica;\n  font-size: 14px;\n  font-weight: 400;\n  left: 33px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 8px;\n}\n\n.dark-version .PROJECT-MANAGEMENT {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 16px;\n  font-weight: 550;\n  left: 28px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  white-space: nowrap;\n}\n\n.dark-version .text-wrapper-26 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 13px;\n  font-weight: 700;\n  left: 745px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  width: 36px;\n}\n\n.dark-version .text-wrapper-27 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 13px;\n  font-weight: 700;\n  left: 816px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  width: 33px;\n}\n\n.dark-version .text-wrapper-28 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 13px;\n  font-weight: 700;\n  left: 884px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  width: 49px;\n}\n\n.dark-version .text-wrapper-29 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 13px;\n  font-weight: 700;\n  left: 968px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  width: 150px;\n}\n\n.dark-version .text-wrapper-30 {\n  color: #ffffff;\n  font-family: \"Lato\", Helvetica;\n  font-size: 13px;\n  font-weight: 700;\n  left: 1085px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  top: 13px;\n  width: 47px;\n}\n\n.dark-version .news-icon {\n  height: 12px;\n  left: 797px;\n  position: relative;\n  top: 16px;\n  width: 14px;\n}\n\n.dark-version .projects-icon-2 {\n  height: 13px;\n  left: 860px;\n  position: relative;\n  top: 15px;\n  width: 16px;\n}\n\n.dark-version .compare-icon {\n  height: 12px;\n  left: 943px;\n  position: relative;\n  top: 16px;\n  width: 16px;\n}\n\n.dark-version .mangehistory-icon {\n  height: 13px;\n  left: 1065px;\n  position: relative;\n  top: 15px;\n  width: 13px;\n}\n\n.dark-version .divider {\n  height: 2px;\n  left: 28px;\n  position: relative;\n  top: 42px;\n  width: 1160px;\n}\n\n.dark-version .hanburg-menu {\n  height: 22px;\n  left: 1174px;\n  position: relative;\n  top: 10px;\n  width: 5px;\n}\n\n.dark-version .rectangle-3 {\n  background-color: #ffffff;\n  border-radius: 23px;\n  height: 5px;\n  left: 0;\n  position: relative;\n  top: 0;\n  width: 5px;\n}\n\n.dark-version .rectangle-4 {\n  background-color: #ffffff;\n  border-radius: 23px;\n  height: 5px;\n  left: 0;\n  position: relative;\n  top: 8px;\n  width: 5px;\n}\n\n.dark-version .rectangle-5 {\n  background-color: #ffffff;\n  border-radius: 23px;\n  height: 5px;\n  left: 0;\n  position: relative;\n  top: 17px;\n  width: 5px;\n}\n\n.dark-version .overlap-5 {\n  background-color: #414141;\n  box-shadow: 0px 0px 15px #00000017;\n  height: 650px;\n  left: -13px;\n  position: relative;\n  top: 87px;\n  width: 105px;\n}\n\n.dark-version .energy {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 10px;\n  font-weight: 600;\n  left: 37px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 36px;\n  white-space: nowrap;\n}\n\n.dark-version .water {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 9px;\n  font-weight: 600;\n  left: 42px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 100px;\n  white-space: nowrap;\n}\n\n.dark-version .communi-cation {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 9px;\n  font-weight: 600;\n  left: 32px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 156px;\n}\n\n.dark-version .finance-revenue {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 9px;\n  font-weight: 600;\n  left: 32px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 221px;\n}\n\n.dark-version .social-sector {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 9px;\n  font-weight: 600;\n  left: 39px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 286px;\n}\n\n.dark-version .govt-of-punjab {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  left: 39px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 362px;\n}\n\n.dark-version .text-wrapper-31 {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 12px;\n}\n\n.dark-version .text-wrapper-32 {\n  font-size: 9px;\n}\n\n.dark-version .govt-of-sindh {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  left: 43px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 492px;\n}\n\n.dark-version .overlap-6 {\n  height: 54px;\n  left: 43px;\n  position: relative;\n  top: 397px;\n  width: 32px;\n}\n\n.dark-version .govt-of-KP {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  left: 0;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 30px;\n}\n\n.dark-version .kp {\n  height: 31px;\n  left: 8px;\n  position: relative;\n  top: 0;\n  width: 22px;\n}\n\n.dark-version .govt-of-balochistan {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  left: 25px;\n  letter-spacing: 0;\n  line-height: 11px;\n  position: relative;\n  text-align: center;\n  top: 555px;\n}\n\n.dark-version .text-wrapper-33 {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 6px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 11px;\n}\n\n.dark-version .text-wrapper-34 {\n  color: #ffffff;\n  font-family: \"Montserrat\", Helvetica;\n  font-size: 9px;\n  font-weight: 600;\n  left: 32px;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n  text-align: center;\n  top: 606px;\n  width: 54px;\n}\n\n.dark-version .finance {\n  height: 22px;\n  left: 47px;\n  position: relative;\n  top: 195px;\n  width: 22px;\n}\n\n.dark-version .socialsector {\n  height: 15px;\n  left: 50px;\n  position: relative;\n  top: 266px;\n  width: 18px;\n}\n\n.dark-version .bulb {\n  height: 26px;\n  left: 46px;\n  position: relative;\n  top: 7px;\n  width: 25px;\n}\n\n.dark-version .comunicatin {\n  height: 18px;\n  left: 47px;\n  position: relative;\n  top: 131px;\n  width: 25px;\n}\n\n.dark-version .water-2 {\n  height: 29px;\n  left: 45px;\n  position: relative;\n  top: 65px;\n  width: 29px;\n}\n\n.dark-version .punjab {\n  height: 25px;\n  left: 51px;\n  position: relative;\n  top: 331px;\n  width: 21px;\n}\n\n.dark-version .balochistan {\n  height: 23px;\n  left: 46px;\n  position: relative;\n  top: 528px;\n  width: 26px;\n}\n\n.dark-version .sindh {\n  height: 22px;\n  left: 49px;\n  position: relative;\n  top: 463px;\n  width: 19px;\n}\n\n.dark-version .line-14 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 55px;\n  width: 75px;\n}\n\n.dark-version .line-15 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 122px;\n  width: 75px;\n}\n\n.dark-version .line-16 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 189px;\n  width: 75px;\n}\n\n.dark-version .line-17 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 259px;\n  width: 75px;\n}\n\n.dark-version .line-18 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 318px;\n  width: 75px;\n}\n\n.dark-version .line-19 {\n  height: 1px;\n  left: 22px;\n  object-fit: cover;\n  position: relative;\n  top: 599px;\n  width: 75px;\n}\n\n.dark-version .logo-wrapper {\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: #d9d9d9;\n  box-shadow: 0px 0px 15px #00000017;\n  height: 87px;\n  left: 1px;\n  position: relative;\n  top: 0;\n  width: 91px;\n}\n\n.dark-version .logo {\n  height: 57px;\n  left: 19px;\n  mix-blend-mode: darken;\n  position: relative;\n  top: 10px;\n  width: 52px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
